import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { JwtInterceptor } from './_Services/common/jwt.interceptor';
import { ErrorInterceptor } from './_Services/common/error.interceptor';
import { routing } from './app.routing';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppTranslateLoader } from './_Services/common/app-translate-loader';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { MainComponent } from './layouts/main.component';
import { WaitingContent, LinkDateParserFormatter } from './components/common';
import { ErrorComponent } from './components/error/error.component'
import { HeaderComponent } from "./components/shared/header/header.component";
import { WorkerMiddlewareService } from './_Services/common/worker.service';
import { DrawerMenuComponent } from './components/shared/drawer-menu/drawer-menu.component';
import { GlobalErrorHandler } from './components/error/GlobalErrorHandler';
import { OAuthModule } from 'angular-oauth2-oidc';
import { DeletePopupComponent } from './components/popups/delete-popup/delete-popup.component';
import { ConfirmPlanComponent } from './components/popups/confirm-plan/confirm-plan.component';
import { CalenderReportDetailsComponent } from './components/calender-report-details/calender-report-details.component';
import { CalenderauditReportDetailsComponent } from './components/calenderaudit-report-details/calenderaudit-report-details.component';
import { GraphExportPopupComponent } from './components/popups/graph-export-popup/graph-export-popup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipesModule } from './components/shared/pipe/pipes.module';
import { DeleteWordingsComponent } from './components/popups/delete-wordings/delete-wordings.component';
import { provideUserIdleConfig } from 'angular-user-idle';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IOAuthService } from './_Services/user/iOAuthService';
import { OAuthCodeFlowService } from './_Services/user/oAuthCodeFlowService';
import { CommentOpenPopupComponent } from './popups/comment-open-popup-quotation/comment-open-popup.component';
import { QuotationHistoryPopupComponent } from './popups/quotation-history-popup-quotation/quotation-history-popup.component';
import { UploadedDocPopupComponent } from './popups/uploaded-doc-popup-quotation/uploaded-doc-popup.component';
import { DocumentUploadPopupComponent } from './popups/document-upload-popup-quotation/document-upload-popup.component';
import { AddFilterComponent } from './popups/add-filter_quotation/add-filter.component';
import { RejectPopupComponent } from './popups/reject-popup/reject-popup.component';
import { AcceptDesignPopupComponent } from './popups/accept-design-popup/accept-design-popup.component';
import { DocumentReuploadPopupComponent } from './popups/document-reupload-popup-quotation/document-reupload-popup.component';
import { SupportingDocumentsPopupComponent } from './popups/supporting-documents-popup/supporting-documents-popup.component';
import { SubmitInvoicePopupComponent } from './components/popups/submit-invoice-popup/submit-invoice-popup.component';
import { ViewInvoiceHistoryPopupComponent } from './components/popups/view-invoice-history-popup/view-invoice-history-popup.component';
import { DocumentInvoiceReuploadPopupComponent } from './popups/document-reupload-popup-invoice/document-invoice-reupload-popup.component';
import { UploadedInvoiceDocPopupComponent } from './popups/uploaded-invoice-popup-quotation/uploaded-invoice-doc-popup.component';
import { RejectInvoicePopupComponent } from './popups/reject-Invoice-popup/reject-invoice-popup.component';
import { SupportingInvoiceDocumentsPopupComponent } from './popups/supporting-invoice-documents-popup/supporting-invoice-documents-popup.component';
import { AcceptInvoiceDesignPopupComponent } from './popups/accept-invocie-popup/accept-invoice-design-popup.component';
const config = require("src/assets/appconfig/appconfig.json");

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        OAuthModule.forRoot(),
        ReactiveFormsModule,
        routing,
        PipesModule,
        NgbModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: AppTranslateLoader,
                deps: [HttpClient]
            },
            isolate: false
        }),
        NgSelectModule,
        BrowserAnimationsModule,  // required animations module
        ToastrModule.forRoot()// ToastrModule added
    ],
    declarations: [
        AppComponent,
        MainComponent,
        WaitingContent,
        ErrorComponent,
        HeaderComponent,
        DrawerMenuComponent,
        DeletePopupComponent,
        ConfirmPlanComponent,
        CalenderReportDetailsComponent,
        CalenderauditReportDetailsComponent,
        GraphExportPopupComponent,
        DeleteWordingsComponent,
        DocumentUploadPopupComponent,
        UploadedDocPopupComponent,
        QuotationHistoryPopupComponent,
        CommentOpenPopupComponent,
        AddFilterComponent,
        RejectPopupComponent,
        AcceptDesignPopupComponent,
        DocumentReuploadPopupComponent,
        SubmitInvoicePopupComponent,
        ViewInvoiceHistoryPopupComponent,
        SupportingDocumentsPopupComponent,
        DocumentInvoiceReuploadPopupComponent,
        UploadedInvoiceDocPopupComponent,
        RejectInvoicePopupComponent,
        AcceptDesignPopupComponent,
        SupportingInvoiceDocumentsPopupComponent,
        AcceptInvoiceDesignPopupComponent,

    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: NgbDateParserFormatter, useClass: LinkDateParserFormatter },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        WorkerMiddlewareService,
        { provide: Window, useValue: window },
        { provide: IOAuthService, useClass: OAuthCodeFlowService },
        provideUserIdleConfig({ idle: config.Idle, timeout: config.Timeout, ping: config.Ping })
    ],
    entryComponents: [WaitingContent, DeletePopupComponent, ConfirmPlanComponent, CalenderReportDetailsComponent, CalenderauditReportDetailsComponent],
    bootstrap: [AppComponent]
})
export class AppModule { }
